/**
 * Handle check box set initiation
 */
export default {
  methods: {
    /**
     * @vuese
     * Init checkbox set and bind accessibility functionality to it
     */
    initCheckBoxSet(inputObj) {
      if (this.inputs.find((input) => input.name === inputObj.name)) {
        return null
      }
      inputObj.el = this.form.find(`[name="${inputObj.name}"]`)
      inputObj.el[0].addEventListener('keypress', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault()
          inputObj.el[0].checked = !inputObj.el[0].checked
        }
      })
      return inputObj
    }
  }
}
